import { createSelector } from 'reselect';

const getReducer = state => state.accessControl;

export const periodEndWeekSelector = createSelector(
  state => getReducer(state).periodEndWeek,
  periodEndWeek => periodEndWeek
);

export const expirationDateTimeSelector = createSelector(
  state => getReducer(state).expirationDateTime,
  expirationDateTime => expirationDateTime
);

export const hamburgerMenuItemsSelector = createSelector(
  state => getReducer(state).hamburgerMenuItems,
  hamburgerMenuItems => hamburgerMenuItems
);
